import React, { Component } from 'react'
import Axios from 'axios';
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter'
import TopBar from '../topbar/topbar'
import search from '../assets/search.png'
import { BASE } from '../api/api';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser'
import './projectDetails.css'
import Loader from 'react-loader'
import { List } from 'react-content-loader';
import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
import ReactPaginate from 'react-paginate';
import load from "../assets/loading.gif"

// import 'bootstrap/dist/css/bootstrap.min.css';

const url = 'http://ifdb-be.tridz.in/'

const project_data = {
    source: {
        lead: "Dr Evren Tok",
        other: "Dr Mustafa Elamin",
        research: "Islam, Reform and Global Affairs",
        year: "June 2020"
    },
    desc: {
        title: "Project Description ",
        desc: {
            sub: "Science, Faith and Innovation for Human Dignity is a program hosted by CIS, HBKU. The program aims to provide a platform to respond to global challenges that undermine social cohesion and human dignity through by bringing together science, faith and innovation. The main objectives of the program are;",
            point1: "Faith driven practices for a sustainaible and resilient world by making it integral in social, economic and environmental innovations to enhance lives and well-being of Muslims.",
            point2: "Cultivate digital safe spaces where ethical behaviour and moral reasoning is promoted.",
        }
    },
    deli: [
        { title: "Bringing Islamic finance to the people", cat: "Book" },
        { title: "Islamic finance by UK institutions", cat: "Book" },
        { title: " Bringing Islamic finance to the people", cat: "Article" }
    ]
}

class ProjectDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            size: 10,
            projectDetails: null,
            includeDetails: [],
            nid: props.match.params.nid
        }
    }
    componentDidMount() {
        Axios.get(`${BASE}jsonapi/node/project?include=field_grant_authoritys,field_grant,field_lead_project__investigator,field_projectinvestigator,field_projects_deliverable,field_projects_deliverable.field_select_work_to_submit,field_cis_cluster,field_grant,field_grant.field_authority&filter[drupal_internal__nid]=${this.state.nid}`)
            .then(data => {
                console.log("details data", data.data.data)
                this.setState({
                    projectDetails: data.data.data[0],
                    title: data.data.data.length ? data.data.data[0].attributes.title : "",
                    includeDetails: data.data.included
                })
                if (data.data.data.length) {
                    if (data.data.data[0].attributes.field_project__date) {
                        const date = new Date(data.data.data[0].attributes.field_project__date)
                        const year = date.getFullYear()
                        const monthNames = ["January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                        ];
                        const month = monthNames[date.getMonth()]
                        console.log("month", year, month)
                        this.setState({
                            years: `${month} ${year}`
                        })

                    }
                    console.log("lead investigator", data.data.data[0].relationships.field_lead_project__investigator.data)
                    if (data.data.data[0].relationships.field_lead_project__investigator.data) {
                        console.log("lead investigator 1", data.data.data[0].relationships.field_lead_project__investigator.data.id)
                        let lead = data.data.included.filter(x => x.id === data.data.data[0].relationships.field_lead_project__investigator.data.id)
                        console.log("lead investigator", lead)
                        if (lead.length) {
                            Axios.get(`${BASE}jsonapi/node/faculty?filter[field_author_faculty.id]=${lead[0].id}`)
                                .then(faculty => {
                                    console.log("faculty in project", faculty.data.data)
                                    if (faculty.data.data.length === 0) {
                                        let leaddetail = {
                                            name: lead[0].attributes.title,
                                            nid: "",
                                            facultylead: ""
                                        }
                                        console.log("lead in project", leaddetail)
                                        this.setState({
                                            leadinvestigator: leaddetail
                                        })
                                    }
                                    else {
                                        let leaddetail = {
                                            name: lead[0].attributes.title,
                                            nid: faculty.data.data[0].attributes.drupal_internal__nid,
                                            facultylead: faculty.data.data[0].attributes.title
                                        }
                                        console.log("lead in project", leaddetail)
                                        this.setState({
                                            leadinvestigator: leaddetail,
                                        })
                                    }
                                })
                                .catch(err => {
                                    console.log("faculty not found", err.message)
                                })
                        }
                    }
                    if (data.data.data[0].relationships.field_projectinvestigator.data.length) {
                        console.log("other investigator 1", data.data.data[0].relationships.field_projectinvestigator.data)
                        let lead = data.data.included.filter(x => x.id === data.data.data[0].relationships.field_projectinvestigator.data.id)
                        console.log("lead investigator", lead)
                        let i, deliverables = []
                        Axios.get(`${BASE}jsonapi/node/faculty`)
                            .then((faculty) => {
                                for (i = 0; i < data.data.data[0].relationships.field_projectinvestigator.data.length; i++) {
                                    let lead = data.data.included.filter(x => x.id === data.data.data[0].relationships.field_projectinvestigator.data[i].id)
                                    if (lead.length) {
                                        let facultydata = faculty.data.data.filter(x => {
                                            let id = x.relationships.field_author_faculty.data.filter(y => {
                                                if (y.id == data.data.data[0].relationships.field_projectinvestigator.data[i].id)
                                                    return y.id
                                            })
                                            // let id = x.relationships.field_author_faculty.data ? x.relationships.field_author_faculty.data.id : ""
                                            if (id.length)
                                                if (lead[0].id === id[0].id)
                                                    return id[0].id
                                        })
                                        if (facultydata.length) {
                                            let leaddetail = {
                                                name: lead[0].attributes.title,
                                                nid: facultydata[0].attributes.drupal_internal__nid,
                                                facultylead: facultydata[0].attributes.title
                                            }
                                            deliverables.push(leaddetail)
                                        }
                                        else {
                                            const datas = {
                                                "name": lead[0].attributes.title,
                                                "nid": "",
                                                facultylead: ""
                                            }
                                            console.log("no faculty found", datas)
                                            deliverables.push(datas)
                                        }
                                    }
                                }
                                this.setState({
                                    otherinvestigator: deliverables
                                }, () => {
                                    console.log("other investigators", this.state.otherinvestigator)
                                })
                            })
                    }
                    if (data.data.data[0].relationships.field_cis_cluster.data) {
                        let cluster = data.data.included.filter(x => x.id === data.data.data[0].relationships.field_cis_cluster.data.id)[0].attributes.title
                        console.log("cluster", cluster)
                        if (cluster) {
                            let aa = cluster.toString()
                            let links = aa.replace(/ /g, '-')
                            this.setState({
                                cluster_link: links
                            })
                        }
                        // data.data.included.filter(x => x.type === "node--research_cluster").length
                    }
                    if (data.data.data[0].relationships.field_projects_deliverable.data.length) {
                        let i = 0, deliverables = []
                        for (i = 0; i < data.data.data[0].relationships.field_projects_deliverable.data.length; i++) {
                            let lead = data.data.included.filter(x => x.id === data.data.data[0].relationships.field_projects_deliverable.data[i].id)
                            if (lead.length) {
                                const datas = {
                                    "title": lead[0].attributes.title,
                                    "nid": lead[0].attributes.drupal_internal__nid,
                                    "type": data.data.included.filter(x => x.id === lead[0].relationships.field_select_work_to_submit.data.id)[0].attributes.name
                                }
                                deliverables.push(datas)
                            }
                        }
                        this.setState({
                            deliverables: deliverables
                        })
                    }

                }
            })
        console.log("nid", this.state.nid)
    }
    render() {
        return (
            <div className='detailed-projects'>
                {!this.state.projectDetails ?
                    <Loader color="#165E84" loaded={false} className="spinner" />
                    : ""}
                <Header />
                <div className="title-banner">
                    <div className='container'>
                        <h1 className="heading-one text-center bold white-text">{this.state.projectDetails ? this.state.projectDetails.attributes.field_project__status == "completed" ? "Completed Projects" : "" : ""}
                            {this.state.projectDetails ? this.state.projectDetails.attributes.field_project__status == "ongoing" ? "Ongoing Projects" : "" : ""}
                            {this.state.projectDetails ? this.state.projectDetails.attributes.field_project__status == "suspended_withdrawn" ? "Suspended / Withdrawn Projects" : "" : ""}
                        </h1>
                    </div>
                </div>
                <div className='container project-details' style={{ minHeight: " 70vh" }}>
                    <div className='subHeader'>
                        <div className='top-contents'>
                            <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /></Link><img className='rightarrow' src={crumbarrow} /><Link to='/projects' className='gray-text'>Projects</Link><img className='rightarrow' src={crumbarrow} />{this.state.title}</div>
                            {/* <TopBar data={'data4'} /> */}
                        </div>
                    </div>

                    <div>
                        <div className='heading-three bold blue-text'>
                            {this.state.title ? this.state.title : ""}
                        </div>
                        {this.state.projectDetails ? <div className='projectSource'>
                            <p className='body-two bold gray-text'>Lead Project Investigator: {this.state.leadinvestigator ? this.state.leadinvestigator.nid ? <Link to={`/faculty/${this.state.leadinvestigator.facultylead}?nid=${this.state.leadinvestigator.nid}`} className="fwt-normal blue-text">{this.state.leadinvestigator ? this.state.leadinvestigator.name : ""}</Link> : <span>{this.state.leadinvestigator.name}</span> : ""}</p>
                            {this.state.otherinvestigator ? <p className='body-two bold gray-text'>Other Project Investigators:  <span>{this.state.otherinvestigator ? this.state.otherinvestigator.map((data, ind) => {
                                console.log("resembling", data)
                                return (
                                    <span>{data.nid ? <Link className="fwt-normal blue-text" to={`/faculty/${data.facultylead}?nid=${data.nid}`}>{data.name}{ind === this.state.otherinvestigator.length - 1 ? "" : "; "}&nbsp;</Link> : <span>{data.name} {ind === this.state.otherinvestigator.length - 1 ? "" : "; "}</span>}</span>
                                )
                            }) : ""}</span></p> : ""}
                            {this.state.projectDetails.relationships.field_cis_cluster.data ?
                                <p className='body-two bold gray-text'>Research Cluster: {this.state.projectDetails.relationships.field_cis_cluster.data ? this.state.includeDetails.filter(x => x.id === this.state.projectDetails.relationships.field_cis_cluster.data.id).length ? <Link to={`/cluster_details/${this.state.cluster_link}`} className="fwt-normal blue-text">{this.state.includeDetails.filter(x => x.id === this.state.projectDetails.relationships.field_cis_cluster.data.id)[0].attributes.title}</Link> : "" : ""}
                                </p> : ""}
                            {this.state.projectDetails.attributes.field_project__status == "completed" ? <p className='body-two bold gray-text'>Year of Completion:  <span className="fwt-normal">{this.state.years ? this.state.years : ''}</span></p> : ""}
                        </div> : ""}

                        {this.state.projectDetails ? <div className='projectStatus'>
                            <table className='newTable'>
                                <tr className='projectStatus-head'>
                                    <th style={{ width: 35 + "%" }}><p> Grant Authority</p></th>
                                    <th><p> Grant Type</p></th>
                                    <th><p> Grant Amount</p></th>
                                    <th><p> Grant Cycle</p></th>
                                </tr>
                                <tr className='projectStatus-row'>
                                    <td><p className='text-align-center'>{this.state.projectDetails ? this.state.projectDetails.relationships.field_grant.data.length ?
                                        this.state.projectDetails.relationships.field_grant.data.map((grant) => {
                                            let authority = this.state.includeDetails.filter(x => x.id === grant.id).length ? this.state.includeDetails.filter(x => x.id === grant.id)[0].relationships.field_authority.data ? this.state.includeDetails.filter(x => x.id === grant.id)[0].relationships.field_authority.data.id : "" : ''
                                            console.log("authority", authority)
                                            return (
                                                <p className="text-center">{authority ? this.state.includeDetails.filter(x => x.id == authority)[0].attributes.name : ""}</p>
                                            )
                                        }) : this.state.includeDetails.filter(x => x.type === "taxonomy_term--authority").length ? this.state.includeDetails.filter(x => x.type === "taxonomy_term--authority")[0].attributes.name : "" : ""}</p></td>
                                    <td><p className='text-align-center'>{this.state.projectDetails ? this.state.projectDetails.attributes.field_grand_types ? this.state.projectDetails.attributes.field_grand_types : "" : ''}</p></td>
                                    <td><p className='text-align-center'>{this.state.projectDetails ? this.state.projectDetails.relationships.field_grant.data.length ?
                                        this.state.projectDetails.relationships.field_grant.data.map((grant) => {
                                            let authority = this.state.includeDetails.filter(x => x.id === grant.id).length ? this.state.includeDetails.filter(x => x.id === grant.id)[0].attributes : ""
                                            console.log("authority", authority)
                                            return (
                                                <p className="text-center">{authority ? `QAR ${authority.field_grant_received_qar_.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : ""}</p>
                                            )
                                        }) : this.state.projectDetails.attributes.field_grand__amount ? `QAR ${this.state.projectDetails.attributes.field_grand__amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : "" : ''}</p></td>
                                    <td><p>{this.state.projectDetails ? this.state.projectDetails.attributes.field_lead_cycles ? this.state.projectDetails.attributes.field_lead_cycles : "" : ''}</p></td>
                                </tr>
                            </table>
                        </div> : ""}

                        {this.state.projectDetails ? <div className="projectDesc">
                            <p className='heading-three blue-text bold'>{project_data.desc.title}</p>
                            <p className='body-two gray-text'>{this.state.projectDetails.attributes.body ? ReactHtmlParser(this.state.projectDetails.attributes.body.value) : ""}</p>

                        </div> : ""}

                        {this.state.projectDetails ? <div className='deliverables' style={{ display: "flex" }}>
                            {this.state.projectDetails.attributes.field_project__status == "ongoing" || this.state.projectDetails.attributes.field_project__status == "completed" ? <p className='subtitle-one deliverables-heading gray-text bold'>{this.state.projectDetails.attributes.field_project__status == "ongoing" ? "Proposed Deliverables:" : "Project Deliverables:"}</p> : ""}
                            <div style={{ marginLeft: 10 + "px", display: "flex", marginTop: "0px" }}>
                                <p className='body-two text-capitalize'>
                                    {this.state.projectDetails.attributes.field_project__status == "ongoing" ? this.state.projectDetails.attributes.field_proposed_deliverables ? this.state.projectDetails.attributes.field_proposed_deliverables : "" : ''}
                                </p>
                                {/* <p className='proposed-deliverables'>
                                    {this.state.projectDetails.attributes.field_project__status == "suspended" ? this.state.projectDetails.attributes.field_proposed_susp_deliverable ? this.state.projectDetails.attributes.field_proposed_susp_deliverable : "" : ''}
                                </p>
                                <p className='proposed-deliverables'>
                                    {this.state.projectDetails.attributes.field_project__status == "withdrawn" ? this.state.projectDetails.attributes.field_proposed_with_deliverable ? this.state.projectDetails.attributes.field_proposed_with_deliverable : "" : ''}
                                </p> */}
                                {this.state.projectDetails.attributes.field_project__status == "completed" ? <div className='single-deliverables'>
                                    {
                                        this.state.deliverables ? this.state.deliverables.map((item) => {
                                            return (
                                                <Link to={`/publication/${item.nid}`} className="blue-text body-two">
                                                    {item.title}
                                                    &nbsp;(<span className=''>{item.type}</span>)
                                                </Link>
                                            )
                                        })
                                            : ""
                                    }
                                </div> : ""}
                            </div>
                        </div> : ""}
                    </div>


                </div>

                <Footer />
            </div>
        )
    }
}
export default ProjectDetails;